import { render } from "./customerhistory.vue?vue&type=template&id=1a139bb6"
import script from "./customerhistory.vue?vue&type=script&lang=js"
export * from "./customerhistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__